const initialState = {
    hospitalPermissions:{},
    hospitalLists: [],
    hospitalHighlightedRecord: null,
    hospitalStatus: [],
    changedHospitalStatus : [],
    addHospitalResponse : [],
    loadingHospital: false,
    isDisabled: true,
    hospitalBasicInfo : [],
    hospitalDetails : [],
    accountDetails : [],
    errorsHospital: {},
    errorsRegistration: {},
    errorsOldData: {},
    errorsTpa: {},
    errorsRmo: {},
    errorsNursing: {},
    hospitalId :'',
    alertData:[],
    grievanceData:[],
    hospitalOldDetail:[],
    hospitalProfile:[],
    registrationDetails : [],
    tpaStaffs:[],
    rmoStaffs:[],
    ownerStaff:[],
    ownerStaffs:[],
    nursingStaffs:[],
    isCashlessAvailable:"",
    hospitalInsuranceCompanies:[],
    rohiniDetail:[],
    message:"",
}

const  hospitalReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_HOSPITALLIST_PENDING":
        case "GET_HOSPITAL_DETAIL_PENDING":
        case "UPDATE_HOSPITAL_PENDING":
        case "UPDATE_HOSPITAL_STATUS_PENDING":
        case "DELETE_HOSPITAL_PENDING":
        case "GET_HOSPITALLISTBYID_PENDING":
        case "GET_HOSPITAL_ACCOUNT_DETAIL_PENDING":
        case "ADD_HOSPITAL_REGISTRATION_DETAILS_PENDING":
        case "GET_HOSPITAL_REGISTRATION_DETAILS_PENDING":
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_PENDING":
        case "ADD_HOSPITAL_STAFF_PENDING":
        case "ADD_UPDATE_HOSPITAL_ACCOUNT_PENDING":
        case "ADD_UPDATE_ROHINI_DETAILS_PENDING":
        case "ADD_UPDATE_HOSPITAL_PROFILE_PENDING":
        case "ADD_UPDATE_HOSPITAL_ALERT_PENDING":
        case "ADD_UPDATE_HOSPITAL_GRIEVANCE_PENDING":
        case "ADD_UPDATE_HOSPITAL_OLD_DATA_PENDING":
        case "ADD_UPDATE_HOSPITAL_TPA_PENDING":
        case "DELETE_HOSPITAL_STAFF_PENDING":
        case "DELETE_HOSPITAL_REGISTRATION_PENDING":
            return { 
                ...state, 
                loadingHospital: true,
                message:""
             };
        case "SET_MESSAGE":
            return { ...state,
                message:action.payload 
            };
        case "SHOW_HOSPITAL_OTHER_FORMS_PENDING":
            return { 
                ...state, 
                loadingHospital: true,
                isDisabled: true,
                addHospitalResponse:[],
                errorsRegistration:{},
                message:"",
                hospitalBasicInfo : [],
                hospitalDetails : [],
                accountDetails : [],
                errorsHospital: {},
                errorsOldData: {},
                errorsTpa: {},
                errorsRmo: {},
                errorsNursing: {},
                hospitalId :'',
                alertData:[],
                grievanceData:[],
                hospitalOldDetail:[],
                hospitalProfile:[],
                registrationDetails : [],
                tpaStaffs:[],
                rmoStaffs:[],
                ownerStaff:[],
                ownerStaffs:[],
                nursingStaffs:[],
                isCashlessAvailable:"",
                hospitalInsuranceCompanies:[],
                rohiniDetail:[],
             };
        case "SHOW_HOSPITAL_OTHER_FORMS_FULFILLED":
            return { 
                ...state, 
                isDisabled: false,
                hospitalId:action.payload,
                message:""
             };

        case "GET_HOSPITALLIST_FULFILLED":
            return {
                ...state,
                loadingHospital: false,
                hospitalLists: action.payload,
                hospitalCount: action.count,
                hospitalPermissions:action.permissions,
            };

        case "ADD_HOSPITAL_FULFILLED":
            return {
                ...state,
                loadingHospital: false,
                addHospitalResponse: action.payload,
                isDisabled:false,
                hospitalId: action.payload?.data?.id,
                message:action.payload?.message,
            };

        case "UPDATE_HOSPITAL_FULFILLED":
            return {
                ...state,
                loadingHospital: false,
                changedHospitalStatus: action.payload,
                message:action.payload?.message,
            };

        case "GET_HOSPITAL_DETAIL_FULFILLED":
            const data = action.payload;
            return {
                ...state,
                loadingHospital: false,
                hospitalDetails: data,
                accountDetails:data?.accountDetail,
                alertData:data?.alert,
                grievanceData:data?.grievance,
                hospitalOldDetail:data?.oldDetail,
                hospitalProfile:data?.profile,
                registrationDetails:data?.registrationDetail,
                tpaStaffs:data?.tpaStaffs,
                rmoStaffs:data?.rmoStaff,
                ownerStaff:data?.ownerStaff,
                ownerStaffs: Array.isArray(data?.ownerStaffs) ? data.ownerStaffs : [],
                nursingStaffs:data?.nursingStaff,
                hospitalInsuranceCompanies:data?.hospitalInsuranceCompanies,
                isCashlessAvailable:data?.is_cashless_facility,
                rohiniDetail:data?.rohiniDetail,
            };

        case "UPDATE_HOSPITAL_STATUS_FULFILLED":
            return {
                ...state,
                loadingHospital: false,
                changedHospitalStatus: action.payload,
            };

        case "GET_HOSPITALLISTBYID_FULFILLED":
            return {
                ...state,
                loadingHospital: false,
                hospitalBasicInfo: action.payload
            };

        case "DELETE_HOSPITAL_FULFILLED":
            return {
                ...state,
                loadingHospital: false,
                changedHospitalStatus: action.payload
            };

        case "RESET_DELETE_HOSPITALS_STATUS":
            return {
                ...state,
                loadingHospital: false,
                changedHospitalStatus: [],
                errorsHospital:{}
            };

        case "GET_HOSPITAL_ACCOUNT_DETAIL_FULFILLED":
            return {
                ...state,
                loadingHospital: false,
                hospitalBasicInfo: action.payload.data
            };
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsRegistration:{},
                message:action.payload?.message,
                hospitalBasicInfo:action.payload?.data,
            };
        case "ADD_HOSPITAL_STAFF_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsHospital:{},
                hospitalBasicInfo:action.payload?.data,
                message:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_ACCOUNT_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsHospital:{},
                hospitalBasicInfo:action.payload?.data,
                message:action.payload?.message,
            };
        case "ADD_HOSPITAL_CASHLESS_STATUS_FULFILLED":
            const hospital = action.payload?.hospital;
            return { 
                ...state, 
                loadingHospital: false,
                errorsHospital:{},
                hospitalBasicInfo:action.payload?.data,
                // isCashlessAvailable:hospital?.is_cashless_facility,
                // hospitalInsuranceCompanies:action.payload?.hospital_insurance_companies,
                message:action.payload?.message,
            };
        case "ADD_UPDATE_ROHINI_DETAILS_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsHospital:{},
                hospitalBasicInfo:action.payload?.data,
                message:action.payload.message,
            };
        case "ADD_UPDATE_HOSPITAL_PROFILE_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsHospital:{},
                hospitalBasicInfo:action.payload?.data,
                message:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_ALERT_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsHospital:{},
                hospitalBasicInfo:action.payload?.data,
                message:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_GRIEVANCE_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsHospital:{},
                hospitalBasicInfo:action.payload?.data,
                message:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_OLD_DATA_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsOldData:{},
                hospitalBasicInfo:action.payload?.data,
                message:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_TPA_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsTpa:{},
                hospitalBasicInfo:action.payload?.data,
                message:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_RMO_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsRmo:{},
                hospitalBasicInfo:action.payload?.data,
                message:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_NURSING_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsNursing:{},
                hospitalBasicInfo:action.payload?.data,
                message:action.payload?.message,
            };
        case "DELETE_HOSPITAL_STAFF_FULFILLED":
            return { 
                ...state, 
                loadingHospital: false,
                errorsNursing:{},
                message:action.payload?.message,
            };

        case "GET_HOSPITALLIST_REJECTED":
        case "ADD_HOSPITAL_REJECTED":
        case "GET_HOSPITAL_DETAIL_REJECTED":
        case "UPDATE_HOSPITAL_REJECTED":
        case "UPDATE_HOSPITAL_STATUS_REJECTED":
        case "DELETE_HOSPITAL_REJECTED":
        case "GET_HOSPITALLISTBYID_REJECTED":
        case "GET_HOSPITAL_ACCOUNT_DETAIL_REJECTED":
        case "ADD_HOSPITAL_REGISTRATION_DETAILS_REJECTED":
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_FULFILLED":
        case "ADD_HOSPITAL_STAFF_REJECTED":
        case "ADD_UPDATE_HOSPITAL_ACCOUNT_REJECTED":
        case "ADD_HOSPITAL_CASHLESS_STATUS_REJECTED":
        case "ADD_UPDATE_ROHINI_DETAILS_REJECTED":
        case "ADD_UPDATE_HOSPITAL_PROFILE_REJECTED":
        case "ADD_UPDATE_HOSPITAL_ALERT_REJECTED":
        case "ADD_UPDATE_HOSPITAL_GRIEVANCE_REJECTED":
        case "DELETE_HOSPITAL_STAFF_REJECTED":
            return {
                ...state,
                loadingHospital: false,
                errorsHospital: action.payload
            };
        // Delete ke success/fail message component toast me dikhata hai - delete ke turant baad
        // Hospital/{id} refetch ka PENDING message clear kar deta hai, isliye yahan message/errors set nahi karte
        case "DELETE_HOSPITAL_REGISTRATION_FULFILLED":
        case "DELETE_HOSPITAL_REGISTRATION_REJECTED":
            return {
                ...state,
                loadingHospital: false,
            };
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_REJECTED":
            return {
                ...state,
                loadingHospital: false,
                errorsHospital: action.payload
            };
        case "ADD_UPDATE_HOSPITAL_OLD_DATA_REJECTED":
            console.log(action.payload,action.payload)
            return {
                ...state,
                loadingHospital: false,
                errorsHospital: action.payload
            };
        case "ADD_UPDATE_HOSPITAL_TPA_REJECTED":
            return {
                ...state,
                loadingHospital: false,
                errorsHospital: action.payload?.data
            };
        case "ADD_UPDATE_HOSPITAL_RMO_REJECTED":
            return {
                ...state,
                loadingHospital: false,
                errorsHospital: action.payload?.data
            };
        case "ADD_UPDATE_HOSPITAL_NURSING_REJECTED":
            return {
                ...state,
                loadingHospital: false,
                errorsHospital: action.payload?.data
            };
        case "SET_HOSPITAL_HIGHLIGHTED_RECORD":
            return { ...state, hospitalHighlightedRecord: action.payload };
        case "CLEAR_HOSPITAL_HIGHLIGHTED_RECORD":
            return { ...state, hospitalHighlightedRecord: null };

        default:
            return state;
    }
}

export default hospitalReducer;